module.exports = __webpack_public_path__ + "fonts/Libre_Franklin-800-latin18.c0aa69c.woff2";